import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	selected: {
		id: 'project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.selected-field.selected',
		defaultMessage: 'Selected',
		description:
			'Message to indicate the field type is selected in the column header dropdown menu',
	},
});
